import React from 'react';
import { notification, Button } from 'antd';

const normalizeMessage = (message) => {
  if (message === null || message === undefined) {
    return 'Done';
  }
  if (typeof message === 'string' || typeof message === 'number') {
    return String(message);
  }
  if (typeof message === 'object') {
    if (typeof message.message === 'string' && message.message.trim() !== '') {
      return message.message;
    }
    try {
      return JSON.stringify(message);
    } catch (e) {
      return 'Done';
    }
  }
  return String(message);
};

export function openNotification(message, placement = 'topRight', onClose) {
  const safeMessage = normalizeMessage(message);
  notification.success({
    message: safeMessage,
    placement,
    duration: 1.5,
    onClose,
  });
}
export function openNotification2(message, placement = 'topRight', options) {
  const safeMessage = normalizeMessage(message);
  // 하위 호환: 4번째 인자로 함수를 바로 넘기던 기존 호출부는 onClose로 취급한다.
  const { duration = 4, onClose, actions } = typeof options === 'function' ? { onClose: options } : options || {};

  const key = `notification2-${Date.now()}`;
  let resolved = false;

  const handleAction = (onClick) => {
    if (resolved) return;
    resolved = true;
    notification.close(key);
    onClick && onClick();
  };

  notification.success({
    key,
    message: safeMessage,
    placement,
    duration,
    btn: actions?.length ? (
      <div style={{ display: 'flex', gap: 8 }}>
        {actions.map((action) => (
          <Button key={action.label} size="small" type={action.type || 'default'} onClick={() => handleAction(action.onClick)}>
            {action.label}
          </Button>
        ))}
      </div>
    ) : undefined,
    onClose: () => {
      if (resolved) return;
      resolved = true;
      onClose && onClose();
    },
  });
}
